import BigNumber from "bignumber.js";
export const serializePolkadotTransaction = ({ amount, recipient, family, mode, fee, era, validators, numOfSlashingSpans, rewardDestination, }) => ({
    amount: amount.toString(),
    recipient,
    family,
    mode,
    fee: fee ? fee.toString() : undefined,
    era,
    validators,
    numOfSlashingSpans,
    rewardDestination,
});
export const deserializePolkadotTransaction = ({ amount, recipient, family, mode, fee, era, validators, numOfSlashingSpans, rewardDestination, }) => ({
    amount: new BigNumber(amount),
    recipient,
    family,
    mode,
    fee: fee ? new BigNumber(fee) : undefined,
    era,
    validators,
    numOfSlashingSpans,
    rewardDestination,
});
//# sourceMappingURL=serializer.js.map